module.exports = __webpack_public_path__ + "static/media/information.490f1637.svg";